module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/ecommerce-header-style3/ecommerce-header-style3.component.scss
// module id = ./src/app/features/headers-styles/ecommerce-header-style3/ecommerce-header-style3.component.scss
// module chunks = main